// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-accordion {
	background-color: var(--Grey50);
	border-color: var(--Grey400);
	width: 100%;
}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-accordionSummary {
	padding-right: 0 !important;
}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-accordionSummary {
	background-color: var(--Grey50);
	-ms-flex-direction: row-reverse;
	    flex-direction: row-reverse;
	width: 100%;
}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-accordionSummary .MuiAccordionSummary-content,
	.csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-accordionSummary .MuiAccordionSummary-content.Mui-expanded {
		margin-left: var(--spacing-2);
		min-width: 0;

	}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-accordionSummary .MuiAccordionSummary-expandIconWrapper {
		margin-left: var(--spacing-5);
	}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-labelName {
	min-width: 0;
}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-list:hover:not(.csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-Mui-selected) {
		background-color: var(--Grey200);
		border-color: var(--Grey500);
	}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-list:focus {
		background-color: var(--Grey200);
		outline: "none";
	}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-list:active:not(.csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-Mui-selected) {
		background-color: var(--NavListItemSelectedBG);
		border-color: var(--PrimaryDefault);
	}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-list.Mui-selected {
		background-color: var(--NavListItemSelectedBG);
		border-color: var(--PrimaryDefault);
		color: var(--PrimaryDefault);
	}

/* React doesn't allow to use display: none here */

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-list:not(:hover) .csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-favoriteButton {
		visibility: hidden;
		width: 0;
		height: 0;
		margin: 0;
	}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-list .csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-favoriteButton {
		margin-left: 4px;
		margin-right: 4px;
	}`, "",{"version":3,"sources":["webpack://./src/csi/middleware/customView/customViewLeftPanel/CustomViewDialogLeftPanelAccordion.module.css"],"names":[],"mappings":"AAAA;CACC,+BAA+B;CAC/B,4BAA4B;CAC5B,WAAW;AACZ;;AAEA;CAGC,2BAA2B;AAa5B;;AAhBA;CACC,+BAA+B;CAC/B,+BAA2B;KAA3B,2BAA2B;CAE3B,WAAW;AAYZ;;AAVC;;EAEC,6BAA6B;EAC7B,YAAY;;CAEb;;AAEA;EACC,6BAA6B;CAC9B;;AAGD;CACC,YAAY;AACb;;AAGC;EACC,gCAAgC;EAChC,4BAA4B;CAC7B;;AAEA;EACC,gCAAgC;EAChC,eAAe;CAChB;;AAEA;EACC,8CAA8C;EAC9C,mCAAmC;CACpC;;AAEA;EACC,8CAA8C;EAC9C,mCAAmC;EACnC,4BAA4B;CAC7B;;AAEA,kDAAkD;;AAClD;EACC,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,SAAS;CACV;;AAEA;EACC,gBAAgB;EAChB,iBAAiB;CAClB","sourcesContent":[".accordion {\n\tbackground-color: var(--Grey50);\n\tborder-color: var(--Grey400);\n\twidth: 100%;\n}\n\n.accordionSummary {\n\tbackground-color: var(--Grey50);\n\tflex-direction: row-reverse;\n\tpadding-right: 0 !important;\n\twidth: 100%;\n\n\t:global .MuiAccordionSummary-content,\n\t:global .MuiAccordionSummary-content.Mui-expanded {\n\t\tmargin-left: var(--spacing-2);\n\t\tmin-width: 0;\n\n\t}\n\n\t:global .MuiAccordionSummary-expandIconWrapper {\n\t\tmargin-left: var(--spacing-5);\n\t}\n}\n\n.labelName {\n\tmin-width: 0;\n}\n\n.list {\n\t&:hover:not(.Mui-selected) {\n\t\tbackground-color: var(--Grey200);\n\t\tborder-color: var(--Grey500);\n\t}\n\n\t&:focus {\n\t\tbackground-color: var(--Grey200);\n\t\toutline: \"none\";\n\t}\n\n\t&:active:not(.Mui-selected) {\n\t\tbackground-color: var(--NavListItemSelectedBG);\n\t\tborder-color: var(--PrimaryDefault);\n\t}\n\n\t&:global(.Mui-selected) {\n\t\tbackground-color: var(--NavListItemSelectedBG);\n\t\tborder-color: var(--PrimaryDefault);\n\t\tcolor: var(--PrimaryDefault);\n\t}\n\n\t/* React doesn't allow to use display: none here */\n\t&:not(:hover) .favoriteButton {\n\t\tvisibility: hidden;\n\t\twidth: 0;\n\t\theight: 0;\n\t\tmargin: 0;\n\t}\n\n\t.favoriteButton {\n\t\tmargin-left: 4px;\n\t\tmargin-right: 4px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accordion": `csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-accordion`,
	"accordionSummary": `csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-accordionSummary`,
	"labelName": `csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-labelName`,
	"list": `csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-list`,
	"Mui-selected": `csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-Mui-selected`,
	"muiSelected": `csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-Mui-selected`,
	"favoriteButton": `csi-middleware-customView-customViewLeftPanel-CustomViewDialogLeftPanelAccordion-module-favoriteButton`
};
module.exports = ___CSS_LOADER_EXPORT___;
